import { render } from "./canales-enlaces.vue?vue&type=template&id=7a86418d"
import script from "./canales-enlaces.vue?vue&type=script&lang=js"
export * from "./canales-enlaces.vue?vue&type=script&lang=js"

import "./canales-enlaces.vue?vue&type=style&index=0&id=7a86418d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__